/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const StartPaymentRedirectDataParser = 
/* #__PURE__ */ parsers.object([
    ['mode', /* #__PURE__ */ parsers.exactly('redirect')],
    ['nextRoute', codecString, 'next_route'],
]);
export class StartPaymentRedirectData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return StartPaymentRedirectDataParser.decode(input).map(res => new StartPaymentRedirectData(res));
    }
    static unsafeDecode(input) {
        return StartPaymentRedirectData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return StartPaymentRedirectDataParser.encode(data);
    }
    static schema() {
        return StartPaymentRedirectDataParser.schema();
    }
}
